import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.36 20.213l-2.36 .787v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414","key":"svg-0"}],["path",{"d":"M15 18a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M20.2 20.2l1.8 1.8","key":"svg-2"}]]

const IconFilterSearch = createReactComponent('outline', 'filter-search', 'FilterSearch', __iconNode);

export default IconFilterSearch;